module.exports = __webpack_public_path__ + "static/media/champion05.e50c3e49.jpg";